import { useMutation } from 'react-query';
import {PartnerApi} from "../../api/partner.api";
import {useVendorsStore} from "../../store/vendors.store";

export const useVendorDocuments = () => {
    const setDocuments = useVendorsStore((state) => state.setDocuments);

    return useMutation(PartnerApi.vendorDocuments, {
        onSuccess: (data) => {
            setDocuments(data);
        },
        onError: (error) => {
            console.error('Login failed:', error);
        },
    });
};